import Request from "../../services/Request";
import ResponseChecker from "../../services/ResponseChecker";

const url = "township/get";
const outsideTowlshipsUrl = "outside_township/get?";

const state = {
  townships: [],
  outside_townships: [],
};
const getters = {};
const mutations = {
  SET_TOWNSHIPS(state, payload) {
    state.townships = payload.data.data;
  },
  SET_OUTSIDE_TOWNSHIPS(state, payload) {
    state.outside_townships = payload.data.data;
  },
};

const actions = {
  async getTownships({ commit }) {
    const response = await Request.get_data(url);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_TOWNSHIPS", response);
  },
  async getAllTownships({ commit }) {
    const response = await Request.get_data('township/get-all');
    if(response.status){
      commit("SET_TOWNSHIPS", response);
    }
  },
  async getOutsideTownships({ commit }, id) {
    const response = await Request.get_data(outsideTowlshipsUrl, {
      township_id: id,
    });
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_OUTSIDE_TOWNSHIPS", response);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
